<app-header></app-header>
<div class="title"></div>

<div class="container table-responsive margin-top-70">
  <div class="d-grid gap-2 d-md-flex justify-content-md-end">
    <button
      class="btn btn-pkt btn-success ms-1"
      type="button"
      (click)="downloadReport()"
    >
      <i class="fa fa-download"></i> Download
    </button>
  </div>
  <div class="" style="overflow-x: scroll;">
    <table
      class="table table-hover table-bordered table-striped mt-2 pkt-table-style"
    >
      <thead class="thead-dark">
        <tr>
          <th scope="col">Product Id</th>
          <th scope="col">Contract Name</th>
          <th scope="col">Author</th>
          <th scope="col">Contract Type</th>
          <th scope="col">Status</th>
          <th scope="col">Title Status</th>
          <th scope="col">Currency</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let product of products; let i = index;">
          <td>{{product.part_number}}</td>
          <td>{{product.name}}</td>
          <td>{{product.author_name}}</td>
          <td>{{product.royalty_type}}</td>
          <td>{{product.status}}</td>
          <td>{{product.product_status}}</td>
          <td>{{Currency[product.contracted_currency_smb]}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<div class="container">
  <app-pagination
    [maxSize]="maxSize"
    [pageSize]="pageSize"
    [collectionSize]="totalProducts"
    (pageChanged)="updatePageData($event)"
  ></app-pagination>
</div>

<app-footer></app-footer>
